import React, { Component } from 'react';
import styles from './Explorer.module.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getView,
  setView,
  getSelected,
  setSelected,
} from '../../modules/explorer';
import { getTags, fetchTags, createTag } from '../../modules/tags';
import {
  saveModels,
  getModel,
  deleteModel,
  exportModel,
  fetchModels,
} from '../../modules/models';
import {
  fetchMaterials,
  saveMaterials,
  getMaterial,
  deleteMaterial,
} from '../../modules/materials';
import Divider from '../../components/Divider';
import DownloadModel from '../../components/DownloadModel';
import Checkbox from 'rc-checkbox';
import Modal from '../../components/Modal';
import DeleteModel from '../../components/DeleteModel';
import { createJob } from '../../modules/jobs';
import { saveAs } from 'file-saver';

class Explorer extends Component {
  state = {
    active: 'view',
    tagView: false,
    modalOpen: false,
    selectedTags: {},
    downloadOpen: false,
    deleteOpen: false,
    batchDownloading: false,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  openTagsView = () => {
    const { tagView } = this.state;
    this.setState({ tagView: !tagView });
  };

  openUploadPage = () => {
    const { router } = this.context;
    const { history, route } = router;
    const { view } = this.props;
    const catogary = view && view.catogary;
    const pathname = route.location.pathname;
    const id = pathname.split('/')[2];
    const url = `/${catogary}/${id}/upload`;
    history.push(url);
  };

  openPreviewPage = () => {
    const { router } = this.context;
    const { history, route } = router;
    const { view } = this.props;
    const catogary = view && view.catogary;
    const pathname = route.location.pathname;
    const id = pathname.split('/')[2];
    const url = `/${catogary}/${id}/preview`;
    history.push(url);
  };

  openViewPage = () => {
    const { view } = this.props;
    const catogary = view && view.catogary;
    const { router } = this.context;
    const { history, route } = router;
    const id = route.location.pathname.split('/')[2];
    if (id) {
      history.push(`/${catogary}/${id}`);
    } else {
      if (catogary === 'models') {
        const { selectedModels } = this.props;
        const modelId = Object.keys(selectedModels)[0];
        //history.push(`/${catogary}/${modelId}`);
        const win = window.open(`/${catogary}/${modelId}`, '_blank');
        win.focus();
      } else if (catogary === 'materials') {
        const { selectedMaterials } = this.props;
        const materialId = Object.keys(selectedMaterials)[0];
        //history.push(`/${catogary}/${materialId}`);
        const win = window.open(`/${catogary}/${materialId}`, '_blank');
        win.focus();
      }
    }
  };

  openSearchPage = async () => {
    const searchValue = this.refs['search'].value;
    if (!searchValue) return;
    const query = {
      limit: 1000,
      friendlyName: searchValue,
    };
    const { fetchModels, fetchMaterials } = this.props;
    await fetchModels(query, 'search');
    await fetchMaterials(query, 'search');
    this.navTo(null, `search?value=${searchValue}`);
  };

  batchDownload = async () => {
    const { view, createJob } = this.props;
    const catogary = view && view.catogary;
    this.setState({ batchDownloading: true });
    let jobAttr = {
      type: 'batch-download',
      catogary,
      syncallback: true,
    };
    if (catogary === 'models') {
      const { selectedModels } = this.props;
      if (selectedModels.length === 0) return;
      jobAttr.models = Object.keys(selectedModels);
    } else if (catogary === 'materials') {
      const { selectedMaterials } = this.props;
      if (selectedMaterials.length === 0) return;
      jobAttr.materials = Object.keys(selectedMaterials);
    } else if (catogary === 'scenes') {
      const { selectedScenes } = this.props;
      jobAttr.scenes = Object.keys(selectedScenes);
    } else {
      console.log('Unknow catogary...');
      return;
    }
    const result = await createJob(jobAttr);
    await saveAs(result, `${catogary}.zip`);
    this.setState({ batchDownloading: false });
  };

  markDiscontinue = async entitystate => {
    const { view, setSelected } = this.props;
    const catogary = view && view.catogary;
    if (catogary === 'models') {
      const { selectedModels, saveModels } = this.props;
      const result = await saveModels(Object.keys(selectedModels), {
        state: entitystate,
      });
      if (result && result.status === 'ok') {
        setSelected(catogary, {});
      } else {
        console.log('failed to save models as discontinued...');
      }
    } else if (catogary === 'materials') {
      const { selectedMaterials, saveMaterials } = this.props;
      const result = await saveMaterials(Object.keys(selectedMaterials), {
        state: entitystate,
      });
      if (result && result.status === 'ok') {
        setSelected(catogary, {});
      } else {
        console.log('failed to save materials as discontinued');
      }
    }
  };

  deleteModel = async () => {
    const { view, deleteModel, deleteMaterial } = this.props;
    const catogary = view && view.catogary;
    const { router } = this.context;
    const { route } = router;
    const id = route.location.pathname.split('/')[2];
    if (catogary === 'models') {
      await deleteModel(id);
      this.setState({ deleteOpen: false });
      router.history.push('/models');
    } else if (catogary === 'materials') {
      await deleteMaterial(id);
      this.setState({ deleteOpen: false });
      router.history.push('/materials');
    }
  };

  openClaraEditor = async () => {
    const { view, getModel, getMaterial, selectedModels } = this.props;
    const catogary = view && view.catogary;
    const { router } = this.context;
    const { route } = router;
    const id = route.location.pathname.split('/')[2];
    if (catogary === 'models') {
      const model = await getModel(id);
      const asset = model.assets.slice(-1).pop();
      if (!asset) return;
      const claraUuid = asset.claraUuid;
      window.open(`https://clara.io/editor/${claraUuid}`, '_blank');
    } else if (catogary === 'materials') {
      const item = await getMaterial(id);
      const asset = item.assets.slice(-1).pop();
      if (!asset) return;
      const claraUuid = asset.claraUuid;
      window.open(`https://clara.io/editor/${claraUuid}`, '_blank');
    }
  };

  async componentDidMount() {
    const { fetchTags } = this.props;
    await fetchTags();
  }

  renderOverView() {
    return (
      <div className={styles.actionBlock}>
        <p
          className={styles.listLabel}
          onClick={e => this.navTo('new', 'projects')}
        >
          + New Project
        </p>
        <p
          className={styles.listLabel}
          onClick={e => this.navTo('new', 'models')}
        >
          + New Model
        </p>
        <p
          className={styles.listLabel}
          onClick={e => this.navTo('new', 'materials')}
        >
          + New Material
        </p>
        <p
          className={styles.listLabel}
          onClick={e => this.navTo('new', 'scenes')}
        >
          + New Scene
        </p>
        <p
          className={styles.listLabel}
          onClick={e => this.navTo('tags', 'admin')}
        >
          + New Tag
        </p>
        <button
          className={styles.imortBatch}
          onClick={e => this.navTo('', 'batchupload')}
        >
          Batch Upload
        </button>
      </div>
    );
  }

  renderUserActions() {}

  closeModal = type => {
    this.setState({ [type]: false });
  };

  handleDownload = async () => {
    const { view, getMaterial } = this.props;
    const catogary = view && view.catogary;
    if (catogary === 'models') {
      this.setState({ downloadOpen: true });
    } else if (catogary === 'materials') {
      const { router } = this.context;
      const { route } = router;
      const id = route.location.pathname.split('/')[2];
      const item = await getMaterial(id);
      if (!item) return;
      const asset = item.assets.slice(-1).pop();
      if (!asset) return;
      if (asset.download) {
        const filename = item.friendlyName + '.zip';
        await saveAs(asset.download, filename);
      }
    } else {
      //HANDLE SCENE
    }
  };

  renderItemView() {
    const { view, getModel, exportModel } = this.props;
    const { deleteOpen, downloadOpen } = this.state;
    const active = view && view.activeLabel;
    const catogary = view && view.catogary;
    const itemType =
      catogary === 'models'
        ? 'Model'
        : catogary === 'materials'
        ? 'Material'
        : 'Scene';
    return (
      <div className={styles.actionBlock}>
        <p
          className={styles.subMenu}
          style={{
            fontWeight: active === 'view' ? 'bold' : 'lighter',
            color: active === 'view' ? '#000' : '',
          }}
          onClick={this.openViewPage}
        >
          View {itemType}
        </p>
        <p
          className={styles.subMenu}
          style={{
            fontWeight: active === 'upload' ? 'bold' : 'lighter',
            color: active === 'upload' ? '#000' : '',
          }}
          onClick={this.openUploadPage}
        >
          Upload {itemType}
        </p>
        <p
          className={styles.subMenu}
          style={{
            fontWeight: active === 'download' ? 'bold' : 'lighter',
            color: active === 'download' ? '#000' : '',
          }}
          onClick={this.handleDownload}
        >
          Download {itemType}
        </p>
        {catogary !== 'scenes' && (
          <p
            className={styles.subMenu}
            style={{
              fontWeight: active === 'preview' ? 'bold' : 'lighter',
              color: active === 'preview' ? '#000' : '',
            }}
            onClick={this.openPreviewPage}
          >
            Preview Materials
          </p>
        )}
        <p
          className={styles.subMenu}
          style={{
            fontWeight: active === 'share' ? 'bold' : 'lighter',
            color: active === 'share' ? '#000' : '',
          }}
        >
          Share
        </p>
        <p
          className={styles.subMenu}
          style={{
            fontWeight: active === 'editor' ? 'bold' : 'lighter',
            color: active === 'editor' ? '#000' : '',
          }}
          onClick={this.openClaraEditor}
        >
          Open in Editor
        </p>
        <p
          className={styles.subMenu}
          style={{
            fontWeight: active === 'delete' ? 'bold' : 'lighter',
            color: active === 'delete' ? '#000' : '',
          }}
          onClick={e => this.setState({ deleteOpen: true })}
        >
          Delete {itemType}
        </p>
        {catogary === 'models' && (
          <DownloadModel
            open={downloadOpen}
            getModel={getModel}
            exportModel={exportModel}
            closeModal={this.closeModal.bind(this, 'downloadOpen')}
          />
        )}
        <DeleteModel
          deleteModel={this.deleteModel}
          type={itemType}
          closeModal={this.closeModal.bind(this, 'deleteOpen')}
          open={deleteOpen}
        />
      </div>
    );
  }

  renderListView() {
    const { tagView, batchDownloading } = this.state;
    const { view } = this.props;
    const catogary = view && view.catogary;
    const itemType =
      catogary === 'models'
        ? 'Model'
        : catogary === 'materials'
        ? 'Material'
        : 'Scene';
    return (
      <div className={styles.listViewContainer}>
        <div className={styles.listLabel}> Actions </div>
        <div className={styles.listView}>
          <p className={styles.listviewLabel} onClick={this.openViewPage}>
            View {itemType}
          </p>

          <p className={styles.listviewLabel}>
            Tags
            <span
              className={tagView ? styles.closeTags : styles.openTags}
              onClick={this.openTagsView}
            >
              <img
                alt="plusIcon"
                width="20px"
                height="20px"
                src="/img/plus.png"
              />
            </span>
          </p>
          {this.renderTags()}

          <p className={styles.listviewLabel}>Rename</p>
          <p className={styles.listviewLabel} onClick={this.batchDownload}>
            Download
            {batchDownloading && (
              <span className={styles.openTags}>
                <img
                  alt="downloadIcon"
                  width="25px"
                  height="25px"
                  src="/img/loading.svg"
                />
              </span>
            )}
          </p>
          <p className={styles.listviewLabel}>Share</p>
          <p className={styles.listviewLabel}>Open in Editor</p>
          <p
            className={styles.listviewLabel}
            onClick={() => this.markDiscontinue('Discontinued')}
          >
            Archive {itemType}
          </p>
          <p
            className={styles.listviewLabel}
            onClick={() => this.markDiscontinue('Active')}
          >
            Unarchive {itemType}
          </p>
        </div>
      </div>
    );
  }

  renderUserListView() {
    const { view } = this.props;
    const active = view && view.activeLabel;
    return (
      <div className={styles.listViewContainer}>
        <div className={styles.listLabel}> Actions </div>
        <div className={styles.listView}>
          <p
            className={styles.listviewLabel}
            style={{
              fontWeight: active === 'assignments' ? 'bold' : 'lighter',
              color: active === 'assignments' ? '#000' : '',
            }}
          >
            My Assignments
          </p>
          <p
            className={styles.listviewLabel}
            style={{
              fontWeight: active === 'notifications' ? 'bold' : 'lighter',
              color: active === 'notifications' ? '#000' : '',
            }}
          >
            My Notifications
          </p>
          <p
            className={styles.listviewLabel}
            style={{
              fontWeight: active === 'edit' ? 'bold' : 'lighter',
              color: active === 'edit' ? '#000' : '',
            }}
            onClick={e => this.navTo('profile', 'users')}
          >
            {' '}
            Edit Profile
          </p>
          <p
            className={styles.listviewLabel}
            style={{
              fontWeight: active === 'manage' ? 'bold' : 'lighter',
              color: active === 'manage' ? '#000' : '',
            }}
            onClick={e => this.navTo('users', 'admin')}
          >
            Manage Users
          </p>
          <p
            className={styles.listviewLabel}
            style={{
              fontWeight: active === 'api' ? 'bold' : 'lighter',
              color: active === 'api' ? '#000' : '',
            }}
          >
            Api Settings
          </p>
          <p
            className={styles.listviewLabel}
            style={{
              fontWeight: active === 'password' ? 'bold' : 'lighter',
              color: active === 'password' ? '#000' : '',
            }}
          >
            Change Password
          </p>
          <p
            className={styles.listviewLabel}
            style={{
              fontWeight: active === 'disable' ? 'bold' : 'lighter',
              color: active === 'disable' ? '#000' : '',
            }}
          >
            {' '}
            Disable My Account{' '}
          </p>
        </div>
      </div>
    );
  }

  renderExplorerView() {
    const { view } = this.props;
    if (view && view.page === 'viewpage')
      return (
        <div>
          {this.renderItemView()} <Divider /> {this.renderOverView()}
        </div>
      );
    if (view && view.page === 'userview') {
      return (
        <div>
          {this.renderUserListView()}
          {this.renderOverView()}
        </div>
      );
    }
    if (view && view.page === 'listview') {
      return (
        <div>
          {this.renderListView()}
          {this.renderOverView()}
        </div>
      );
    }
    return this.renderOverView();
  }

  toggleTagModal = open => {
    this.setState({ modalOpen: open });
  };

  renderTags() {
    const { tagView, modalOpen } = this.state;
    const { tags, createTag } = this.props;
    if (!tagView) return null;
    return (
      <div className={styles.tagPannel}>
        {tags.map(tag => (
          <div className={styles.tagRow} key={tag[0].value}>
            <Checkbox id={tag[0].value} onChange={this.selectTags} />
            <div className={styles.tagLabel}> {tag[0].label}</div>
          </div>
        ))}
        <button className={styles.applyTags} onClick={this.applyTags}>
          Apply Tags
        </button>
        <Divider />
        <p
          className={styles.createNewTag}
          onClick={e => this.toggleTagModal(true)}
        >
          Create new tag
        </p>
        <Modal
          open={modalOpen}
          title="Create New Tag"
          createTag={createTag}
          closeModal={e => this.toggleTagModal(false)}
        />
      </div>
    );
  }

  selectTags = e => {
    const { selectedTags } = this.state;
    const { id, checked } = e.target;
    if (checked) {
      selectedTags[id] = true;
    } else {
      delete selectedTags[id];
    }
    this.setState({ selectedTags });
  };

  applyTags = async () => {
    const { selectedTags } = this.state;
    const {
      saveModels,
      view,
      selectedModels,
      selectedMaterials,
      saveMaterials,
    } = this.props;
    const tags = Object.keys(selectedTags);
    const catogary = view && view.catogary;
    if (catogary === 'models') {
      const res = await saveModels(Object.keys(selectedModels), { tag: tags });
      if (res.status === 'ok') {
        this.setState({ selectedTags: {}, tagView: false });
      }
    } else if (catogary === 'materials') {
      const res = await saveMaterials(Object.keys(selectedMaterials), {
        tag: tags,
      });
      if (res.status === 'ok') {
        this.setState({ selectedTags: {}, tagView: false });
      }
    } else if (catogary === 'scenes') {
    }
  };

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.searchContainer}>
          <img
            alt="search"
            src="/img/search.svg"
            className={styles.searchIcon}
            onClick={this.openSearchPage}
          />
          <input
            ref="search"
            className={styles.search}
            onKeyPress={e => {
              if (e.key === 'Enter') this.openSearchPage();
            }}
            placeholder="Search"
          />
        </div>
        {this.renderExplorerView()}
      </div>
    );
  }
}

const stateToProps = state => ({
  view: getView(state),
  tags: getTags(state),
  selectedModels: getSelected('models', state),
  selectedMaterials: getSelected('materials', state),
  selectedScenes: getSelected('scenes', state),
});

export default connect(
  stateToProps,
  {
    setView,
    fetchTags,
    createTag,
    saveModels,
    fetchModels,
    getMaterial,
    saveMaterials,
    fetchMaterials,
    getModel,
    deleteModel,
    deleteMaterial,
    exportModel,
    createJob,
    setSelected,
  }
)(Explorer);



// WEBPACK FOOTER //
// ./src/containers/Explorer/index.js